/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AppComponent} from '../../../../app.component'
import * as moment from 'moment';
import {LoginService, PrincipalService} from '../../../../shared';
import {AccountType} from '../../../../shared/types/account.type';
import {AccountResourceService} from '../../../../shared';
import {TokenService} from '../../../../shared/services/token.service';

@Component({
  selector: 'navbarProfile',
  templateUrl: 'profile.component.html',
  styleUrls: ['./../navbar.component.scss']
})
export class NavbarProfileComponent implements OnInit {
  languages;
  accountDetails;
  langFinal = [];
  account: AccountType;
  accountData: string;
  currentLang: string;
  selectedLang;
  isNavbarCollapsed = true;
  isLanguageBoxOpen = false;

  constructor(private app: AppComponent,
              private principal: PrincipalService,
              private loginService: LoginService,
              private tokenService: TokenService,
              private translate: TranslateService,
              public accountResourceService: AccountResourceService) {
    this.getUserAccount();

  }

  ngOnInit() {
    this.getUserAccount();
  }

  getUserAccount() {
    const token = this.tokenService.secureGet("token");
    this.accountResourceService.get(token).subscribe((account: AccountType) => {
      this.account = account;
      this.account.lastSuccessfulLogin = moment(this.account.lastSuccessfulLogin).format('DD MMM YYYY hh:mm a');
    });
  }

  logout() {
    const timout = false;
    this.account = null;
    this.principal.authenticate(null);
    this.loginService.logout(timout);
  }


}
